module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAURJREFUOE+dkqFLBEEUxr+3t7AXV/DYCQaDwegfYDhBsBouKBgEgxcsNpvYbGpTMCgIFoNRQfCC3WoRg+He3CKrHBt2WfbpLONyCncLO+kxzO+973vzEWoespyrlNoWEXdSHyLKmPkMQFaAvu/7zWazD+CwQsBekiQqiqKvAmy1WnOO4zwD2KiYeJXn+cJgMHgtQKXUPoA1EXmpAOdF5FRrfTIKgpkPJoFmgIh8lmAQBFsAlrXW61ZBm5l71sZiGIZPpg6C4JqI7pj58tejajQafRG5NZsD0BmtAdxYJZ04jqeHw+FHuVXP895FpGsfPBgFpnZd9z7LshXTkIjOkySZKbdqvsPzvLcf7VNW0hGAtm3S01rv2vsoTdPZsaBS6hHATp7nruM4x8y8NBb8F4BN49E8JqJVABd2+t8AGCu1Ilcn598yqqUPEMSpMgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Icon/Storefollowings.png
// module id = c9Zw
// module chunks = 82